import React from 'react';
import clsx from 'clsx';
import CategoryDropdown from 'components/molecules/CategoryDropdown/CategoryDropdown';
import SearchInput from 'components/atoms/SearchInput/SearchInput';
import { CategoryOption } from 'components/molecules/CategoryOptionsModal/CategoryOptionsModal';
import classes from './OffersControls.module.scss';

interface Props {
  categories: CategoryOption[];
  selectedCategory: string;
  onCategorySelect: (tag: string) => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  listRef?: React.Ref<HTMLDivElement>;
  className?: string;
}

const OffersControls: React.FC<Props> = ({
  categories,
  selectedCategory,
  onCategorySelect,
  searchQuery,
  onSearchChange,
  listRef,
  className,
}) => {
  return (
    <div className={clsx(classes.controls, className)}>
      <CategoryDropdown
        categories={categories}
        selectedCategory={selectedCategory}
        onCategorySelect={onCategorySelect}
        listRef={listRef}
        className={classes.dropdownWrapper}
      />
      <SearchInput value={searchQuery} onChange={onSearchChange} className={classes.searchInput} />
    </div>
  );
};

export default OffersControls;
